import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiUserCheck, FiCheckCircle, FiEyeOff, FiTrendingUp } = FiIcons;

const WhyNamvoro = () => {
  const reasons = [
    {
      icon: FiAward,
      title: "Enterprise-Grade Reliability",
      description: "Built on proven infrastructure trusted by Fortune 500 companies worldwide."
    },
    {
      icon: FiUserCheck,
      title: "White-Glove Onboarding",
      description: "Dedicated specialists guide you through every step of the implementation process."
    },
    {
      icon: FiCheckCircle,
      title: "Legal & IT-Aligned Workflows",
      description: "Processes designed to meet corporate compliance and governance requirements."
    },
    {
      icon: FiEyeOff,
      title: "Confidential Service Delivery",
      description: "Discreet, professional service with strict confidentiality protocols."
    },
    {
      icon: FiTrendingUp,
      title: "Uptime-Focused Operations",
      description: "99.9% uptime guarantee with proactive monitoring and rapid response."
    }
  ];

  return (
    <section id="why-namvoro" className="py-20 gradient-navy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Why Choose Namvoro?
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Experience the difference of working with true digital brand management professionals.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="glass-effect rounded-2xl p-8 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={reason.icon} className="w-6 h-6 text-emerald-400" />
              </div>

              <h3 className="text-xl font-bold text-white mb-4">
                {reason.title}
              </h3>

              <p className="text-slate-300 leading-relaxed">
                {reason.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="glass-effect rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Trusted by Corporations Around the Globe — Discreetly
            </h3>
            <p className="text-slate-300 text-lg">
              Our clients value privacy as much as performance. We protect not just your digital assets, 
              but your competitive advantage through confidential, professional service delivery.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyNamvoro;